export default __webpack_public_path__ + "static/media/hero-img.b876d31c.png";